module.exports = __webpack_public_path__ + "static/media/lawIcon.c51a005e.svg";